export const TKeyFAQ = {
  FAQ: "FAQ",
  FAQ_TITLE: "FAQ_TITLE",
  FAQ_MEIDLY_2_TITLE: "FAQ_MEIDLY_2_TITLE",
  FAQ_MEIDLY_2_TEXT: "FAQ_MEIDLY_2_TEXT",
  FAQ_MEIDLY_2_TEXT_2: "FAQ_MEIDLY_2_TEXT_2",
  FAQ_MEIDLY_2_TEXT_3: "FAQ_MEIDLY_2_TEXT_3",
  FAQ_MEIDLY_3_TITLE: "FAQ_MEIDLY_3_TITLE",
  FAQ_MEIDLY_3_TEXT: "FAQ_MEIDLY_3_TEXT",
  FAQ_MEIDLY_3_TEXT_2: "FAQ_MEIDLY_3_TEXT_2",
  FAQ_MEIDLY_6_TITLE: "FAQ_MEIDLY_6_TITLE",
  FAQ_MEIDLY_6_TEXT: "FAQ_MEIDLY_6_TEXT",
  FAQ_MEIDLY_6_TEXT_2: "FAQ_MEIDLY_6_TEXT_2",
  FAQ_MEIDLY_6_TEXT_3: "FAQ_MEIDLY_6_TEXT_3",
  FAQ_MEIDLY_START_TITLE: "FAQ_MEIDLY_START_TITLE",
  FAQ_MEIDLY_START_TEXT: "FAQ_MEIDLY_START_TEXT",
  FAQ_MEIDLY_ACCESS_TITLE: "FAQ_MEIDLY_ACCESS_TITLE",
  FAQ_MEIDLY_ACCESS_TEXT: "FAQ_MEIDLY_ACCESS_TEXT",
  FAQ_MEIDLY_ACCESS_TEXT_2: "FAQ_MEIDLY_ACCESS_TEXT_2",
  FAQ_MEIDLY_START_TEXT_2: "FAQ_MEIDLY_START_TEXT_2",
  FAQ_MEIDLY_BOT_TITLE: "FAQ_MEIDLY_BOT_TITLE",
  FAQ_MEIDLY_BOT_TEXT: "FAQ_MEIDLY_BOT_TEXT",
  FAQ_MEIDLY_BOT_TEXT_2: "FAQ_MEIDLY_BOT_TEXT_2",
  FAQ_MORE_TITLE: "FAQ_MORE_TITLE",
  FAQ_MORE_TEXT: "FAQ_MORE_TEXT",
} as const;
